import React from 'react';
import { Button, Space, Switch, Tag, Tooltip, message } from 'antd';
import { ExperimentOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { AcceptanceManifest } from './types';
import { useAcceptanceMode } from './AcceptanceModeContext';
import { AcceptanceChangeRequestButton } from './AcceptanceChangeRequestButton';

interface Props {
  manifest: AcceptanceManifest;
  onAutoFill: () => void;
  autoFillDisabled?: boolean;
  autoFillReason?: string;
  documentKey?: string;
}

export const AcceptanceToolbar: React.FC<Props> = ({ manifest, onAutoFill, autoFillDisabled, autoFillReason, documentKey }) => {
  const {
    providerMounted,
    globalEnabled,
    canManageGlobal,
    settingsLoading,
    enabledForms,
    isEnabled,
    setGlobalEnabled,
    setFormEnabled,
  } = useAcceptanceMode();
  if (!providerMounted) return null;
  const enabled = isEnabled(manifest.formId);

  return (
    <div style={{ padding: '10px 14px', marginBottom: 12, border: '1px solid #91caff', background: enabled ? '#e6f4ff' : '#fafafa', borderRadius: 8 }}>
      <Space wrap>
        <ExperimentOutlined style={{ color: enabled ? '#1677ff' : undefined }} />
        <strong>驗收模式</strong>
        <Switch checked={enabled} disabled={globalEnabled} onChange={checked => setFormEnabled(manifest.formId, checked)} />
        <Tag color="blue">{manifest.chainId}</Tag>
        {canManageGlobal && <span>管理者全表單</span>}
        {canManageGlobal && <Switch
          checked={globalEnabled}
          loading={settingsLoading}
          onChange={async checked => {
            try {
              await setGlobalEnabled(checked);
              message.success(checked ? '已開啟全系統驗收模式' : '已關閉全系統驗收模式');
            } catch {
              message.error('更新全系統驗收模式失敗');
            }
          }}
        />}
        {enabled && (
          <Tooltip title={autoFillReason}>
            <Button
              data-acceptance-auto-fill={manifest.formId}
              icon={<ThunderboltOutlined />}
              onClick={onAutoFill}
              disabled={autoFillDisabled}
            >自動填表</Button>
          </Tooltip>
        )}
        {enabled && <AcceptanceChangeRequestButton
          manifest={manifest}
          contextType="form"
          documentKey={documentKey}
          label="提出表單 Contract 變更"
        />}
        {!globalEnabled && enabledForms[manifest.formId] && <Tag color="green">此表單已開啟</Tag>}
        {globalEnabled && <Tag color="purple">管理者全域啟用</Tag>}
      </Space>
    </div>
  );
};
